import React from "react";
import { StyledCard } from "../../style";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { useSelector } from "react-redux";
import { Switch } from "../../../../components/Inputs/Input";
import AssociacaoTelas from "../../components/AssociacaoTelas";
import AssociacaoLojas from "../../components/AssociacaoLojas";

const ModulosLojasTab = () => {
  const { perfilDeAcessoBeingVisualizedData, isInVisualizeMode } = useSelector(
    (state) => state.perfilAcesso
  );
  return (
    <div className="d-flex flex-column">
      <StyledCard>
        <Row>
          <Col md={4}>
            <FormGroup>
              <Label
                style={{
                  fontWeight: "700",
                  color: "var(--color-preto)",
                }}
              >
                Perfil
              </Label>
              {`${isInVisualizeMode}`}
              <Input
                type="text"
                placeholder="Digite aqui..."
                value={perfilDeAcessoBeingVisualizedData.descricao}
                disabled={isInVisualizeMode}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Switch
              componentRight="Este perfil irá utilizar a hierarquia como filtro de visualização?"
              className="switch"
              checked={perfilDeAcessoBeingVisualizedData.isHierarquia}
              disabled={isInVisualizeMode}
            />
          </Col>
          <Col md={6}>
            <Switch
              componentRight="Exibir CPF?"
              className="switch"
              checked={perfilDeAcessoBeingVisualizedData.isAdministrativo}
              disabled={isInVisualizeMode}
            />
          </Col>
        </Row>
      </StyledCard>
      <StyledCard>
        <div style={{ padding: "20px" }}>
          <AssociacaoTelas />
        </div>
      </StyledCard>
      {!perfilDeAcessoBeingVisualizedData.isHierarquia && (
        <StyledCard>
          <div style={{ padding: "20px" }}>
            <AssociacaoLojas />
          </div>
        </StyledCard>
      )}
    </div>
  );
};

export default ModulosLojasTab;
